<h1 class="mb-4">
  <mdb-icon fas icon="cog"></mdb-icon> Ventas Específicas
</h1>
<!-- Heading -->
<div class="card card-miga-pan mb-2 wow">
  <!--Card content-->
  <div class="card-body d-sm-flex p-1 justify-content-between">
    <p class="mb-0">
      <span class="grey-text">Reportes y Consulta</span>
      <span> /</span>
      <span class="grey-text">Ventas</span>
      <span> /</span>
      <span>Ventas Específicas</span>
    </p>
  </div>
</div>
<!-- Heading -->

<!-- Cabecera de botones -->
<form autocomplete="off" [formGroup]="formHeader">
  <div class="card mb-2 wow detalle-cliente">
    <div class="card-body justify-content-between">
      <!-- <div class="row filtros-header" style="border-bottom: 1px solid #dee2e6">
      <div></div>
      <button
        type="button"
        mdbBtn
        color="info"
        (click)="showNew(); showModalAgregar()"
        size="sm"
        mdbWavesEffect
      >
        Agregar
      </button>
    </div> -->
      <div class="row mb-2 filtros-body">
        <div class="col" style="max-width: 200px">
          <div class="md-form mb-0">
            <mdb-date-picker [inline]="true" name="fechaDesde" [placeholder]="'Desde'" required
              formControlName="fechaDesde"></mdb-date-picker>
            <ng-container *ngIf="
              formHeader.get('fechaDesde').invalid &&
              (formHeader.get('fechaDesde').dirty ||
              formHeader.get('fechaDesde').touched)">
              <mdb-error *ngIf="formHeader.get('fechaDesde').hasError('required')">Ingrese fecha desde</mdb-error>
              <mdb-error *ngIf="formHeader.get('fechaDesde').hasError('rangeDate')">Periodo consulta no debe ser mayor a 12 meses</mdb-error>
            </ng-container>
          </div>
        </div>
        <div class="col" style="max-width: 200px">
          <div class="md-form mb-0">
            <mdb-date-picker [inline]="true" name="fechaHasta" [placeholder]="'Hasta'" required
              formControlName="fechaHasta"></mdb-date-picker>
            <ng-container *ngIf="
              formHeader.get('fechaHasta').invalid &&
              (formHeader.get('fechaHasta').dirty ||
              formHeader.get('fechaHasta').touched)">
                <mdb-error *ngIf="formHeader.get('fechaHasta').hasError('required')">Ingrese fecha hasta</mdb-error>
                <mdb-error *ngIf="formHeader.get('fechaHasta').hasError('rangeDate')">Periodo consulta no debe ser mayor a 12 meses</mdb-error>
            </ng-container>
          </div>
        </div>
        <div class="col" style="
                    display: flex;
                    align-items: center;
                    justify-content: center;
                  ">
          <!-- <div class="md-form">
                    <mdb-select [options]="optionsTiposCliente" [multiple]="true" [filterEnabled]="true"
                      [highlightFirst]="false" placeholder="Todos" formControlName="listaTipoCliente"></mdb-select>
                    <label>Tipo de Cliente</label>
                  </div> -->
          <strong>Buscar por: </strong>
          <!-- Material inline 1 -->
          <div class="form-check form-check-inline">
            <input type="radio" class="form-check-input" id="rpt_cliente_especifico_rbBuscarPor_cliente"
              formControlName="buscarPor" [value]="TIPO_TIPO_CLIENTE" mdbInput (change)='limpiarBuscarPorCliente()' />
            <label class="form-check-label" for="rpt_cliente_especifico_rbBuscarPor_cliente">Tipo cliente</label>
          </div>

          <!-- Material inline 2 -->
          <div class="form-check form-check-inline">
            <input type="radio" class="form-check-input" id="rpt_cliente_especifico_rbBuscarPor_tipo_cliente"
              formControlName="buscarPor" [value]="TIPO_CLIENTE" mdbInput (change)='limpiarBuscarPorTiposClientes()' />
            <label class="form-check-label" for="rpt_cliente_especifico_rbBuscarPor_tipo_cliente">Cliente</label>
          </div>
          <div class="col">
            <button mdbBtn type="button" class="btn-cuadrado" color="secondary" mdbWavesEffect
              (click)="abrirModalSeleccion()">
              <mdb-icon fas icon="search"></mdb-icon>
            </button>
            <ng-container *ngIf="formHeader.get('buscarPor').value === TIPO_CLIENTE">
              <button mdbBtn type="button" class="" color="info" mdbWavesEffect
                (click)="abrirModalSeleccionarClienteSeleccionados()" *ngIf="clientesSeleccionados?.length > 0">
                ({{clientesSeleccionados.length | numerico}}) Seleccionados
              </button>
            </ng-container>
            <ng-container *ngIf="formHeader.get('buscarPor').value === TIPO_TIPO_CLIENTE">
              <button mdbBtn type="button" class="" color="info" mdbWavesEffect
                (click)="abrirModalSeleccionarTiposClienteSeleccionados()"
                *ngIf="tiposClientesSeleccionados?.length > 0">
                ({{tiposClientesSeleccionados.length | numerico}}) Seleccionados
              </button>
            </ng-container>
          </div>
          <div class="col" style="max-width: 300px">
            <div class="md-form">
              <mdb-select [options]="optionsRubro" [multiple]="true" [filterEnabled]="true" [highlightFirst]="false"
                placeholder="Todos" formControlName="listaRubro"></mdb-select>
              <label>Rubro de Productos</label>
            </div>
          </div>
          <div class="col" style="max-width: 300px">
            <div class="md-form">
              <mdb-select [options]="optionsFamilia" [multiple]="true" [filterEnabled]="true" [highlightFirst]="false"
                placeholder="Todos" formControlName="listaFamilia"></mdb-select>
              <label>Familia de Productos</label>
            </div>
          </div>
        </div>
      </div>



      <!-- <div class="col" style="max-width: 300px;">
          <button mdbBtn type="button" class="btn-cuadrado" color="secondary" mdbWavesEffect
            (click)="seleccionarCliente.show()">
            <mdb-icon fas icon="search"></mdb-icon>
          </button>
          <h6 class="text-info" style="display: contents;">
            Nombre de cliente/sucursal
          </h6>
        </div> -->

    </div>

    <!-- FOOTER -->
    <div class="card-footer text-muted filtros-footer" style="border-top: 1px solid #dee2e6">
      <div class="resultados pl-2"></div>
      <div>
        <button mdbBtn type="button" color="secondary" size="sm" mdbWavesEffect (click)="LimpiarData()">Limpiar</button>
        <button mdbBtn type="button" color="secondary" size="sm" mdbWavesEffect (click)="buscar(1)">
          <mdb-icon fas icon="search"></mdb-icon>
          Buscar
        </button>
      </div>
    </div>
  </div>
</form>

<!-- Listado -->
<div class="card mb-2 wow">
  <div class="card-body p-1 justify-content-between">
    <div *ngIf="loading" class="w-100 d-block text-center">
      <mdb-spinner *ngIf="loading" spinnerColor="blue"></mdb-spinner>
    </div>
    <div class="table-responsive">
      <table class="table table-striped table-hover table-sm align-middle" *ngIf="listaMovimientos">
        <thead class="grey lighten-2">
          <tr>
            <th scope="col">Tipo</th>
            <th scope="col">RUT</th>
            <th scope="col">Nombre</th>
            <th scope="col">Dirección</th>
            <th scope="col">Ciudad</th>
            <th scope="col">Comuna</th>
            <th scope="col">Tipo Doc.</th>
            <th scope="col">Folio</th>
            <th scope="col">Fecha Registro</th>
            <th scope="col">Monto Neto</th>
            <th scope="col">Descuento</th>
            <th scope="col" class="doble-linea text-right">Total Neto</th>
          </tr>
        </thead>
        <tbody>
          <tr *ngFor="let mov of listaMovimientos">
            <td>{{ mov.tipo_cliente_nombre }}</td>
            <td>{{ mov.rutFormato | rut}}</td>
            <td>{{ mov.razon_social }}</td>
            <td>{{ mov.direccion_completa }}</td>
            <td>{{ mov.nombreprovincia }}</td>
            <td>{{ mov.nombrecomuna }}</td>
            <td>{{ mov.tipo_dte_nombre }}</td>
            <td>{{ mov.folio | numerico }}</td>
            <td>{{ mov.fecha_registro | fecha}}</td>
            <td class="text-right">{{ mov.monto_neto | numerico }}</td>
            <td class="text-right">{{ mov.descuento | numerico }}</td>
            <td class="text-right">{{ mov.neto_total | numerico }}</td>
          </tr>
        </tbody>
        <tbody class="blue lighten-5">
          <tr>
            <td class="text-right" colspan="9"><strong>Totales</strong></td>
            <td>{{ resumen_totales.monto_neto | numerico}}</td>
            <td>{{ resumen_totales.descuento | numerico}}</td>
            <td>{{ resumen_totales.neto_total | numerico}}</td>
          </tr>
        </tbody>
        <app-pagination [context]="paginationContext" (onPageChange)="onPageChange($event)"
          *ngIf="listaMovimientos?.length > 0"></app-pagination>
      </table>
    </div>
  </div>
</div>

<div class="card mb-2 wow" *ngIf="listaMovimientos?.length > 0">
  <div class="card-body d-sm-flex p-1 justify-content-end">
    <button size="sm" mdbBtn type="button" color="success" mdbWavesEffect class="btn btn-sm"
      (click)="downloadExcelPdf('XLS')">
      Excel
    </button>
  </div>
</div>

<!-- MODAL seleccionarCliente -->
<app-modal-seleccionar-cliente (onSelectMultiple)="onClienteSeleccionadoMultiple($event)" queryType="ONLY_RUT"
  (onSelectSingle)="onClienteSeleccionado($event)">
</app-modal-seleccionar-cliente>

<!-- MODAL seleccionarTipoCliente -->
<app-modal-seleccionar-cliente-tipos (onSelectMultiple)="onClienteTiposSeleccionado($event)">
</app-modal-seleccionar-cliente-tipos>
